import axios from "../../axios/index.js"


export default {
    
    GetAll(no) {
        return axios.get("reporting/listbl/" + no, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
    },

}
